module.exports = __webpack_public_path__ + "assets/img/FeaturedKanban.dc40ef6a.png";